import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { NotFoundComponent } from './not-found.component';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule.forChild([
      {
        path: 'notfound',
        component: NotFoundComponent,
      },
    ]),
  ],
  declarations: [NotFoundComponent],
})
export class FeatureNotFoundModule {}
